import React from "react";
import styled from "styled-components";
import { defineMessages, FormattedMessage } from "react-intl";
const msgs = defineMessages({
    description: {
        id: "maxCartItemsReached.message",
        description: "message shown when the max number of items that can be added to a cart has been reached",
        defaultMessage: "You cannot add more items to the cart",
    },
    accept: {
        id: "agency.modal.button.accept",
        description: "Accept",
        defaultMessage: "Accept",
    },
});
const Container = styled.div `
  text-align: center;
  margin-bottom: 7px;
  padding: 0 18px;
`;
const Button = styled.button `
  cursor: pointer;
  padding: 9.5px 28px;
  text-transform: uppercase;
  border: 1px solid #3d933a;
  color: #3d933a;
  font-weight: bold;
  border-radius: 3px;
  font-size: 14px;
  transition: background-color 0.4s, color 0.4s;
  margin: 10px 0;

  &:hover {
    background-color: #3d933a;
    color: #fff;
  }
`;
const ButtonContainer = styled.div `
  margin-top: 13px;
`;
const Content = styled.div `
  font-size: 14px;
  font-weight: bold;
`;
function MaxCartItemsModal({ closeWindow }) {
    return (<Container>
      <Content>
        <FormattedMessage {...msgs.description}/>
      </Content>

      <ButtonContainer>
        <Button onClick={closeWindow}>
          <FormattedMessage {...msgs.accept}/>
        </Button>
      </ButtonContainer>
    </Container>);
}
export default MaxCartItemsModal;
